import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

function getCookie(name)
{
  const keypairs = document.cookie.split(";");

  for(const keypair of keypairs)
  {
    const kv = keypair.split(";");

    if(kv[0] == name)
    {
      return kv[1];
    }
  }
}

export default new Vuex.Store({
  state: {
    cultureCode: getCookie("language") || "en",
    user: {},
    countries: [],
    waterSystems: [],
    allAssets: [],
    loading: false,
    notification:
    {
      show: false,
      text: null,
      className: null
    }
  },
  mutations: {
    updateState(state, obj)
    {
      if(obj.target)
      {
        let value = obj.value;

        if(typeof obj.value != "string")
        {
          value = JSON.stringify(obj.value);
        }
      }

      state[obj.name] = obj.value;
    }
  },
  actions: {}
});
